import { ReactComponent as HamburgerIcon } from "assets/icons/hamburger.svg";
import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { AppRoutes } from "routing";
import { RootState } from "store";
import LogoEAdviser from "../../../../assets/images/LogoESavjetnik.svg";
import LogoEAdviser_LowVision from "../../../../assets/images/LogoEAdviser_LowVision.svg";
import { Navigation } from "../Navigation";
import { ProfileSettings } from "../ProfileSettings";
import { AccessibilityContext } from "views/AccessibilityContext";
import { classNames } from "helpers/ClassNameHelper";

interface Props {
    setMenuOpen: () => void;
    closeHamburgerMenu: () => void;
}

export const MainHeader: React.FC<Props> = ({ setMenuOpen, closeHamburgerMenu }) => {
    const isUserLoggedIn = useSelector((state: RootState) => state.signIn?.signInSuccess);
    const { lowVision } = useContext(AccessibilityContext);

    const logoEAdviser = lowVision ? LogoEAdviser_LowVision : LogoEAdviser;
    return (
        <header className="header-container container-x">
            <Link to={AppRoutes.Home} className="header-logo-link" onClick={closeHamburgerMenu}>
                <img src={logoEAdviser} alt="Logo eSavjetnik" className="header-logo" />
            </Link>
            <div className="header-navigation">
                <Navigation />
            </div>
            {isUserLoggedIn ? (
                <div className="header-profile">
                    <ProfileSettings />
                </div>
            ) : (
                <a
                    className={classNames("header-login-button", lowVision && "low-vision")}
                    href="https://epoljoprivreda.mps.hr/"
                >
                    Prijava
                </a>
            )}
            <div className="header-hamburger">
                <HamburgerIcon onClick={setMenuOpen} />
            </div>
        </header>
    );
};
